import { render, staticRenderFns } from "./punctuality.vue?vue&type=template&id=7a443c2f&scoped=true"
import script from "./punctuality.vue?vue&type=script&lang=js"
export * from "./punctuality.vue?vue&type=script&lang=js"
import style0 from "./punctuality.vue?vue&type=style&index=0&id=7a443c2f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a443c2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a443c2f')) {
      api.createRecord('7a443c2f', component.options)
    } else {
      api.reload('7a443c2f', component.options)
    }
    module.hot.accept("./punctuality.vue?vue&type=template&id=7a443c2f&scoped=true", function () {
      api.rerender('7a443c2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/CollectKanban/cmp/punctuality.vue"
export default component.exports